/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-15 09:29:32
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-11-05 20:01:55
 */
import Vue from 'vue';
import pageLoading from './pi-loading.vue';

const SuccessBoxConstructor = Vue.extend(pageLoading);

let getAnInstance = () => {
  return new SuccessBoxConstructor({
    el: document.createElement('div')
  });
};

let pageLoadingBox = {
  timer: null,
  open() {
    clearTimeout(this.timer);
    var div = document.getElementById('pi-loading');
    if (!div) {
      let instance = getAnInstance();
      this.obj = instance;
      document.body.appendChild(instance.$el);
    } else {
      div.style.display = 'block';
    }
  },
  closeIndex: 0,
  close() {
    this.timer = setTimeout(() => {
      var div = document.getElementById('pi-loading');
      if (div) {
        div.style.display = 'none';
      }
    }, 100);
  }
};

export default pageLoadingBox;
